<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="12"
        :form-context="formContext"
        icon="inticon-users"
        title="Schadendienstleister">
        <b-row>
            <div class="col-6">
                <p class="mb-0">SD-Firma</p>
                <p>
                    <span v-if="firmData.name"><b>{{ firmData.name }}</b><br/></span>
                    <span v-if="firmData.street">{{ firmData.street }}<br/></span>
                    <span v-if="firmData.postalCode || firmData.city">
                        {{ firmData.postalCode }} {{ firmData.city }}<br/>
                    </span>
                    <span v-if="firmData.countryName">{{ firmData.countryName }}<br/></span>
                </p>
                <p>
                    <span v-if="firmData.phone">{{ firmData.phone }}<br/></span>
                    <span v-if="firmData.email">
                            <a :href="'mailto:' + firmData.email">{{ firmData.email }}</a>
                        </span>
                </p>
            </div>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="SD-Sachbearbeiter"
                property="damageServiceProviderUser"
                :required="true"
                type="autocomplete">
                <template v-slot:display-value>
                    <p>
                        <span v-if="userData.name"><b>{{ userData.name }}</b><br/></span>
                        <span v-if="userData.street">{{ userData.street }}<br/></span>
                        <span v-if="userData.postalCode || userData.place">
                        {{ userData.postalCode }} {{ userData.place }}<br/>
                    </span>
                        <span v-if="userData.countryName">{{ userData.countryName }}<br/></span>
                    </p>
                    <p>
                        <span v-if="userData.phone">{{ userData.phone }}<br/></span>
                        <span v-if="userData.email">
                        <a :href="'mailto:' + userData.email">{{ userData.email }}</a>
                    </span>
                    </p>
                </template>
            </csp-desktop-info-card-element>
        </b-row>
    </csp-desktop-info-card>
</template>

<script>
import FormDataMixin from '../../mixins/FormDataMixin';

export default {
    name: 'ParticipantDSP',
    mixins: [FormDataMixin],
    computed: {
        recordId() {
            return this.$route.params.recordId;
        },
        userData() {
            return {
                'name': this.formContext.form.getProperty('userName') ?? '',
                'street': this.formContext.form.getProperty('userStreet') ?? '',
                'postalCode': this.formContext.form.getProperty('userPostalCode') ?? '',
                'place': this.formContext.form.getProperty('userPlace') ?? '',
                'countryName': this.formContext.form.getProperty('userCountryName') ?? '',
                'phone': this.formContext.form.getProperty('userPhone') ?? '',
                'email': this.formContext.form.getProperty('userEmail') ?? '',
            };
        },
        firmData() {
            return {
                'name': this.formContext.form.getProperty('firmName') ?? '',
                'street': this.formContext.form.getProperty('firmStreet') ?? '',
                'postalCode': this.formContext.form.getProperty('firmPostalCode') ?? '',
                'city': this.formContext.form.getProperty('firmCity') ?? '',
                'countryName': this.formContext.form.getProperty('firmCountryName') ?? '',
                'phone': this.formContext.form.getProperty('firmPhone') ?? '',
                'email': this.formContext.form.getProperty('firmEmail') ?? '',
            };
        },
    },
}
</script>
